/**
 * AUTO-GENERATED — DO NOT EDIT
 *
 * Generated by tools/gen-sqlite-from-db-schema.ts
 * To regenerate, run: pnpm powersync:schema:generate
 */

import { sqliteTable, text } from 'drizzle-orm/sqlite-core';

export const patients = sqliteTable('patients', {
  id: text('id').primaryKey().notNull(),
  patient_number: text('patient_number'),
  full_name: text('full_name'),
  birth_date: text('birth_date'),
  sex: text('sex'),
  photo_url: text('photo_url'),
  last_visited_at: text('last_visited_at'),
  status: text('status'),
  title: text('title'),
  local_name: text('local_name'),
  country_of_birth: text('country_of_birth'),
  marital_status: text('marital_status'),
  shift: text('shift'),
  nationality: text('nationality'),
  race: text('race'),
  literacy_level: text('literacy_level'),
  religion: text('religion'),
  occupation: text('occupation'),
  referred_by: text('referred_by'),
  department_name: text('department_name'),
  job_position: text('job_position'),
  assigned_doctor: text('assigned_doctor'),
  location: text('location'),
  blood_group_abo: text('blood_group_abo'),
  blood_group_rh: text('blood_group_rh'),
  drug_allergies_notes: text('drug_allergies_notes'),
  food_allergies_notes: text('food_allergies_notes'),
  medical_notes: text('medical_notes'),
  medical_alerts: text('medical_alerts'),
  past_medication_notes: text('past_medication_notes'),
  current_medication_notes: text('current_medication_notes'),
  medical_history: text('medical_history'),
  created_at: text('created_at'),
  updated_at: text('updated_at'),
});
